import React from 'react'
import { Tooltip } from 'antd-v4'
import { ExclamationCircleTwoTone, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons'
import { COLORS } from '../../../../../../constants/Colors'

interface Props {
  valueChanged: boolean
  syncSuccessful: boolean | undefined
  syncAttempted: boolean
  onClick: () => void
}

type TIconField =
  | {
      title: string
      icon: JSX.Element
    }
  | undefined

export const AuditSyncIndicator = (props: Props) => {
  const { valueChanged, syncAttempted, syncSuccessful, onClick } = props

  let iconField: TIconField

  switch (true) {
    case syncSuccessful === true:
      iconField = {
        title: 'Sync successful',
        icon: <CheckCircleTwoTone twoToneColor={COLORS.green400} onClick={onClick} />,
      }
      break

    case syncSuccessful === false:
      iconField = {
        title: 'Sync unsuccessful. Click to retry',
        icon: <CloseCircleTwoTone twoToneColor={COLORS.red400} onClick={onClick} />,
      }
      break

    case valueChanged:
      iconField = {
        title: 'Sync required',
        icon: <ExclamationCircleTwoTone twoToneColor={COLORS.grey} onClick={onClick} />,
      }
      break

    case !valueChanged && syncAttempted:
      iconField = {
        title: 'Already synced',
        icon: <CheckCircleTwoTone twoToneColor={COLORS.green400} onClick={onClick} />,
      }
      break

    case !valueChanged && !syncAttempted:
      iconField = undefined
      break

    default:
      iconField = {
        title: 'Sync unsuccessful. Click to retry',
        icon: <CloseCircleTwoTone twoToneColor={COLORS.red400} onClick={onClick} />,
      }
  }

  return iconField ? <Tooltip title={iconField.title}>{iconField.icon}</Tooltip> : null
}
